/* Gift popup on phones, 2026-10-25. The popup (built by stryd-offers.js) is a bottom sheet on phones and stays open
   until Done; with the cart drawer open it covered Secure checkout and the order total. While the popup is up, this
   lifts it to sit just above the checkout button and adds .is-docked (styles: assets/stryd-cart.css). Drawer closed:
   bottom sheet as before. Desktop is placed by stryd-offers.js and left alone here. */
(function () {
  'use strict';
  var BTN = '[data-essential-cart-element="cart-drawer-checkout-button"]';
  var timer = null;

  function place() {
    var t = document.querySelector('.stryd-gift-toast');
    if (!t) { clearInterval(timer); timer = null; return; }
    if (window.innerWidth >= 750) {
      if (t.classList.contains('is-docked')) { t.classList.remove('is-docked'); t.style.bottom = ''; }
      return;
    }
    var cb = document.querySelector(BTN);
    var r = cb && cb.getBoundingClientRect();
    var docked = !!(r && r.width > 0 && r.top > 0 && r.top < window.innerHeight);
    var b = docked ? Math.round(Math.min(window.innerHeight - r.top + 8, window.innerHeight - t.offsetHeight - 8)) + 'px' : '';
    if (t.style.bottom !== b) t.style.bottom = b;
    t.classList.toggle('is-docked', docked);
  }

  // the drawer opens, scrolls and redraws while the popup is up, so keep checking until it is gone
  new MutationObserver(function () {
    if (!timer && document.querySelector('.stryd-gift-toast')) { place(); timer = setInterval(place, 200); }
  }).observe(document.body, { childList: true });
})();